import React from 'react';
import moment from 'moment';
import { capitalizeAll } from './components/Helpers';
import MaleAvatar from '../../assets/images/MaleAvatar.svg';
import RecommendedGreen from '../../assets/images/RecommendedGreen.svg';
import RecommendedRed from '../../assets/images/RecommendedRed.svg';
import RecommendedYellow from '../../assets/images/RecommendedYellow.svg';
export const Profile = ({ data }) => {
    return (
        <>
            <div className="profile-div">
                <div className="profile-img-div">
                    <img className="profile-img-logo" src={data?.image ?? MaleAvatar} alt="Logo" />
                </div>
                <div className="profile-details-div desktop-mode">
                    <span className="common-profile-text profile-intId common-profile-text-block">{data?.code}</span>
                    <span className="common-profile-text profile-details-text common-profile-text-block">
                        {capitalizeAll(data?.name)} | {capitalizeAll(data?.position)}
                    </span>
                    <span className="common-profile-text profile-contact common-profile-text-block">
                        {data?.email} | {data?.phone}
                    </span>
                    <span className="common-profile-text profile-contact common-profile-text-block">
                        Date of Interview: {moment(data?.interviewDate).format('llll')}
                    </span>
                    {data?.interviewDuration && (
                        <span className="common-profile-text profile-contact common-profile-text-block">
                            Interview Duration: {Math.floor(Number(data?.interviewDuration) / 60)} mins{' '}
                            {Number(data?.interviewDuration) % 60 > 0
                                ? `${Math.floor(Number(data?.interviewDuration) % 60)}`
                                : ''}{' '}
                            {Number(data?.interviewDuration) % 60 > 0 ? `secs` : ''}
                        </span>
                    )}
                </div>
                <div className="profile-details-status">
                    <img
                        className="profile-recommended-img"
                        src={
                            data?.finalRating > 6
                                ? RecommendedGreen
                                : data?.finalRating > 4
                                  ? RecommendedYellow
                                  : RecommendedRed
                        }
                        alt="Logo"
                    />
                </div>
            </div>
            <div className="profile-details-div mobile-mode">
                <div className="profile-details-div-1">
                    <span className="common-profile-text profile-intId d-block">{data?.code}</span>
                    <span className="common-profile-text profile-details-text d-block">
                        {capitalizeAll(data?.name)} | {capitalizeAll(data?.position)}
                    </span>
                    <span className="common-profile-text profile-contact d-block">
                        {data?.email} | {data?.phone}
                    </span>
                    <span className="common-profile-text profile-contact d-block">
                        Date of Interview: {moment(data?.interviewDate).format('llll')}
                    </span>
                    {data?.interviewDuration && (
                        <span className="common-profile-text profile-contact d-block">
                            Interview Duration: {Math.floor(Number(data?.interviewDuration) / 60)} mins{' '}
                            {Number(data?.interviewDuration) % 60 > 0
                                ? `${Math.floor(Number(data?.interviewDuration) % 60)}`
                                : ''}{' '}
                            {Number(data?.interviewDuration) % 60 > 0 ? `secs` : ''}
                        </span>
                    )}
                </div>
            </div>
        </>
    );
};
